(() => {
  if (window.bfcmTermsInitialized) return;
  window.bfcmTermsInitialized = true;

  if (!customElements.get('bfcm-terms-host')) {
    customElements.define('bfcm-terms-host', class extends HTMLElement {
      connectedCallback() {
        this.modal = this.querySelector('x-modal') || this.modal;
      }

      disconnectedCallback() {
        const modal = this.modal;
        if (modal?.parentElement !== document.body) return;
        const closed = !modal.hasAttribute('open') && !modal.hidden
          ? new Promise((resolve) => modal.addEventListener('modal:afterHide', resolve, { once: true }))
          : Promise.resolve(modal.hide?.());
        closed.then(() => {
          if (!this.isConnected) modal.remove();
        });
      }
    });
  }

  const findModal = (id) => id
    ? document.getElementById(id)
    : document.getElementById('BfcmTermsDialog') || document.querySelector('x-modal.bfcm-terms-modal[data-bfcm-default-terms]');

  const open = async (id, trigger = null) => {
    const modal = findModal(id);
    if (!modal?.matches('x-modal.bfcm-terms-modal')) return false;
    await customElements.whenDefined('x-modal');
    if (!modal.isConnected) return false;
    modal.show(trigger);
    return true;
  };
  window.bfcmTerms = { open };

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented) return;
    const trigger = event.target.closest('[data-bfcm-terms], a[href="#bfcm-terms"], a[href^="#bfcm-terms:"]');
    if (!trigger) return;
    let id = trigger.dataset.bfcmTerms || trigger.getAttribute('aria-controls');
    if (!id && trigger.hash?.startsWith('#bfcm-terms:')) {
      try { id = decodeURIComponent(trigger.hash.slice('#bfcm-terms:'.length)); } catch { return; }
    }
    const modal = findModal(id);
    if (!modal?.matches('x-modal.bfcm-terms-modal')) return;
    event.preventDefault();
    open(id, trigger);
  });
})();
